import { createActionTypes } from 'utils/action/actionTypes';

export const CREATE_RESERVE_SLOTS = createActionTypes('CREATE_RESERVE_SLOTS');
export const FETCH_RESERVE_SLOTS = createActionTypes('FETCH_RESERVE_SLOTS');
export const GET_RESERVE_SLOTS = createActionTypes('GET_RESERVE_SLOTS');
export const DELETE_RESERVE_SLOTS = createActionTypes('DELETE_RESERVE_SLOTS');
export const UPDATE_RESERVE_SLOTS = createActionTypes('UPDATE_RESERVE_SLOTS');
export const ALL_USERS_IN_RESERVE_SLOTS = createActionTypes('ALL_USERS_IN_RESERVE_SLOTS');
export const CREATE_BULK_USERS_TO_RESERVE_SLOTS = createActionTypes('CREATE_BULK_USERS_TO_RESERVE_SLOTS');
